import { useMemo } from 'react';
import { useIntl } from 'react-intl';
import { useParams } from 'react-router-dom';

import {
  getConsolidatedForecastingUrl,
  getReportingUrl,
  PREDICT_PRODUCT_SLUG,
  ROUTES
} from '@futrli/shared-services';

import { ConsolidatedForecastingContainer } from '../../forecast/containers/consolidated-forecasting-container';
import { NavItem } from '../components/navbar/types';
import { ReportingContainer } from '../../report-builder/containers/reporting-container';

export const useConsolidationManagementRoutes = () => {
  const intl = useIntl();
  const { organisationId: tempOrganisationId, workspaceId: tempWorkspaceId } = useParams();

  const organisationId = tempOrganisationId || '';
  const workspaceId = tempWorkspaceId || '';

  const output = useMemo(() => {
    const routes: NavItem[] = [
      {
        name: intl.formatMessage({ id: 'predict.forecasting', defaultMessage: 'Forecasting' }),
        route: `${ROUTES.FORECASTS}/*`,
        component: ConsolidatedForecastingContainer,
        url: getConsolidatedForecastingUrl(workspaceId, organisationId, PREDICT_PRODUCT_SLUG)
      },
      {
        name: intl.formatMessage({ id: 'predict.reporting', defaultMessage: 'Reporting' }),
        route: `${ROUTES.REPORTING}/*`,
        component: ReportingContainer,
        url: getReportingUrl(workspaceId, organisationId, true)
      }
    ];

    return {
      routes,
      redirect: {
        to: getConsolidatedForecastingUrl(workspaceId, organisationId, PREDICT_PRODUCT_SLUG)
      }
    };
  }, [organisationId, workspaceId, intl]);

  return output;
};
